<template>
  <div
    class="edit-div"
    v-html="innerText"
    :contenteditable="canEdit"
    @focus="scrollTop"
    @blur="lock"
    @input="changeText"
    ref="textArea"
  ></div>
</template>
import { getStore } from "assets/commonjs/storage";
<script type="text/ecmascript-6">
export default {
  name: "editDiv",
  props: {
    value: {
      type: String,
      default: ""
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  data() {
    return {
      innerText: this.value,
      isLocked: false
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          if (!this.isLocked || !this.innerText) {
            this.innerText = this.$el.innerHTML + val;
            this.$emit("input", this.innerText);
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    changeText() {
      this.$emit("input", this.$el.innerHTML);
    },
    clearText() {
      this.$el.innerHTML = "";
      this.innerText = "";
    },
    lock() {
      this.isLocked = false;
      //兼容ios键盘事件
      window.scrollTo(0, document.documentElement.clientHeight);
    },
    addChild(content) {
      this.$refs.textArea.appendChild(content);
      this.$emit("input", this.$el.innerHTML);
    },
    scrollTop() {
      this.isLocked = true;
      this.$emit("scrollTop");
    }
   
  }
};
</script>
<style lang="scss" rel="stylesheet/scss">
.edit-div {
  width: 100%;
  height: 100%;
  overflow: auto;
  word-break: break-all;
  outline: none;
  user-select: text;
  white-space: pre-wrap;
  text-align: left;
  min-height: 0.4rem;
  line-height: 0.4rem;
  padding-top: 0.1rem;
  max-height: 1.3rem;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  -webkit-tap-highlight-color: transparent;
  user-select: text;
  caret-color: #0a95ff;
  &[contenteditable="true"] {
    user-modify: read-write-plaintext-only;
    &:empty:before {
      content: attr(placeholder);
      display: block;
      color: #ccc;
    }
  }
  img {
    vertical-align: middle;
    width:.5rem;
    height: .5rem;
  }
}
</style>